import React from 'react';
import Milxc from './Milxc';
import AnimatedStatistics from './Reminders/AnimatedStatistics';
import CiaTriad from './Reminders/CiaTriad';
import Protections from './Reminders/Protections';
import CyberDefinition from './Reminders/Quote';
import Risks from './Reminders/Risks';
import Threats from './Reminders/Threats';

export default function Content() {
  const styles = {
    heading: {
      color: 'white'
    },
    imgMusk: {
      width: '600px',
      height: '600px'
    }
  };
  return (
    <>
      <section data-background-color="CadetBlue">
        <h1 style={styles.heading}>Rappels cybersécurité</h1>
      </section>

      <section>
        <CyberDefinition />
      </section>

      <CiaTriad />

      <AnimatedStatistics />

      <Risks />

      <Threats />

      <Protections />

      <Milxc />
    </>
  );
}
